/**
 * @desc 非空校验
 * @author nieling
 * @date 2020-06-01 19:47:04
 */
export function isNullString(targetStr) {
  if (!(targetStr || '')) {
    return true
  }
  return false
}

/**
 * @desc email 校验
 * @author nieling
 * @date 2020-06-01 19:47:36
 */
export function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * @desc 手机号校验
 * @author nieling
 * @date 2020-06-01 19:49:22
 */
export function testPhone(content) {
  var regExp = /^1[3|5|7|8|][0-9]{9}$/
  if (regExp.test(content)) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/tools.js